module.exports = "<div class=\"product-promo-box rounded row\" >\r\n        <img class=\"not-all-pdts-available-dsk\" ng-src=\"{{ctrl.promoImage}}\"\r\n        alt=\"icon\" >\r\n<!-- <span ng-class=\"ctrl.isIpad() ? 'col-md-8':  'col-md-10'\" style=\"padding:0px;\" >Not all products are available at every WBU Store Location</span> -->\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/product-promo/product-promo.html
// module id = 288
// module chunks = 0